import { render, staticRenderFns } from "./InputWithValidation.vue?vue&type=template&id=481a7120"
import script from "./InputWithValidation.vue?vue&type=script&lang=js"
export * from "./InputWithValidation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports